module.exports = __webpack_public_path__ + "assets/img/Interreg-2025.4c0f7122.jpg";